<template>
    <div class="templete_box"  v-if="code==0">
        <div class="templete">
            <div class="search_box clearfix">
                <el-select class="search_select search_inputBox" v-model="params.sync_status" placeholder="同步状态">
                    <el-option :value="0" label="未同步"></el-option>
                    <el-option :value="1" label="已同步"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.sync_cube_pct" placeholder="同步百分比">
                    <el-option :value="20" label="20"></el-option>
                    <el-option :value="50" label="50"></el-option>
                    <el-option :value="80" label="80"></el-option>
                    <el-option :value="100" label="100"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.breed_id" multiple collapse-tags placeholder="品名" @visible-change="getSelectWarehouseList('breed_id')">
                    <el-option v-for="list in selectMapC.breed_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.brand_id" multiple collapse-tags placeholder="品牌" @visible-change="getSelectWarehouseList('brand_id')">
                    <el-option v-for="list in selectMapC.brand_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.grade_id" multiple collapse-tags placeholder="等级" @visible-change="getSelectWarehouseList('grade_id')">
                    <el-option v-for="list in selectMapC.grade_id" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" v-model="params.thickness" placeholder="厚度" size="mini"></el-input>
                <el-input class="search_input search_inputBox" v-model="params.length" placeholder="长度" size="mini"></el-input>
                <el-select class="search_select search_inputBox"  v-model="params.area_id" multiple collapse-tags placeholder="区域">
                    <el-option v-for="list in locationList" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.is_promo" placeholder="同步属性">
                    <el-option :value="0" label="正常推广"></el-option>
                    <el-option :value="1" label="特价促销"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="syncClick">自定义同步</el-button>
                <el-button class="funcPublicBtn" @click="oneSync">一键同步</el-button>
                <el-button class="funcPublicBtn" @click="tiao">云铺定价</el-button>
                <el-button class="funcPublicBtn" @click="cancelSync">撤销同步</el-button>
                <div class="imgIcon"> 
                    <img src="/icon/browse.png" style="width:20px;">
                    <span>浏览次数：{{view.view_count}}</span>
                </div>
                <div class="imgIcon"> 
                    <img src="/icon/contact.png" style="width:17px;">
                    <span>联系次数：{{view.contact_count}}</span>
                </div>
                <div class="imgIcon"> 
                    <img src="/icon/follow.png" style="width:17px;">
                    <span>被关注：{{view.follow_count}}</span>
                </div>
                <div class="upimgBtnBox" @click="filterDialogVisibleClose">
                    <div class="phoneSetImg"></div>
                    <div class="upimgBtnTitle">电话设置</div>
                </div>
                <div class="upimgBtnBoxB" @click="yunpuInstallDialogClose">
                    <div class="dianpuSetImg"></div>
                    <div class="upimgBtnTitle" style="padding-right: 15px;">云铺设置</div>
                </div>
                <div class="upimgBtnBox"  @click="bacthUpImg">
                    <div class="upimgBtnImg"></div>
                    <div class="upimgBtnTitle">上传图片</div>
                </div>
            </div>
            <div class="tableBox">
                <tabletem  scene="inventory.sync.spots" :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @dialogViewClick="dialogViewClick"></tabletem>
            </div>
            <div class="totalCal">
                <div class="totalName">合计：</div>
                <div class="totalNumber">库存方数: {{totalObj.sales_cube}}</div>
                <div class="totalNumber">同步云铺方数: {{totalObj.sync_cube}}m³</div>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <saleMan :tableData="salefilter" scene="erp/cloud.store.user.list" :filterDialogVisible="filterDialogVisible" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></saleMan>
        <!-- :tableData="filter" scene="inventory.sync.spots" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}" -->
        <!-- 一键同步 START -->
        <el-dialog width="450px" v-dialog-drag title="一键同步" :visible.sync="oneSyncdialogVisibleSync" class="eldialog eldialogYunpu" :modal="false" custom-class="full_dialog">
            <el-form :model="onesync" class="clearfix dialogFormB">
                <el-form-item  label="同步方数百分比：">
                    <el-select v-model="onesync.sync_cube_pct">
                        <el-option :value="20" label="20%"></el-option>
                        <el-option :value="50" label="50%"></el-option>
                        <el-option :value="80" label="80%"></el-option>
                        <el-option :value="100" label="100%"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="textDiv">
                <div><i class="iconfont icon-note tip_top"></i></div>
                <div class="textStyle">
                    <span class="spanBlock">1.一健同步不需要勾选库存，会默认全部被选中同步</span>
                    <span class="spanBlock">2.同步方数百分比是按汇总方数的百分比显示云铺方数</span>
                </div>
            </div>
            <!-- <div>
                <div><span class="tip_top"><i class="iconfont icon-jindianzi returnImg"></i>注意:</span>1.一健同步不需要勾选库存，会默认全部被选中同步</div>
                <div style="padding-left: 48px;">2.同步方数百分比是按汇总方数的百分比显示云铺方数</div>
            </div> -->
            <div class="elFormBoxBtnListCol">
                <el-button class="funcPublicBtn" @click="oneSyncdialogVisibleSync=!oneSyncdialogVisibleSync" style="margin-right:15px!important;">取消</el-button>
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="onesaveSync">确认</el-button>
            </div>
        </el-dialog>
        <!-- 一键同步 END -->
        <!-- 云铺同步 START -->
        <el-dialog width="500px" v-dialog-drag title="自定义同步" :visible.sync="dialogVisibleSync" class="eldialog eldialogYunpu" :modal="false" custom-class="full_dialog">
            <el-form :model="sync" class="clearfix dialogFormB">
                <el-form-item  label="自定义百分比：">
                    <el-input v-model="sync.sync_cube_pct">
                         <template slot="append">%</template>
                    </el-input>
                    <!-- <el-select v-model="sync.sync_cube_pct">
                        <el-option :value="20" label="20%"></el-option>
                        <el-option :value="50" label="50%"></el-option>
                        <el-option :value="80" label="80%"></el-option>
                        <el-option :value="100" label="100%"></el-option>
                    </el-select> -->
                </el-form-item>
                <el-form-item  label="同步到促销专区:">
                    <!-- <el-radio v-model="sync.is_promo" label=""></el-radio> -->
                    <img :src="sync.is_promo == 1?'/cloud/checked.png':'/cloud/check.png'" class="syncImg" @click="sync.is_promo = sync.is_promo==1?0:1"/>
                </el-form-item>
                <div class="textDiv">
                    <div><i class="iconfont icon-note tip_top"></i></div>
                    <div class="textStyle">
                        <span class="spanBlock">1.用户可完全自主同步(手动输入)1%-100%之间的库存数据到企业云铺和现货云仓。</span>
                        <span class="spanBlock">2.有尾货或着急变现的仓库可以勾选同步到促销专区，提高展现率，有助快速出货。</span>
                        <span class="spanBlock">3.使用ERP的系统用户同步的库存必须是真实的库存数据，如有上传同步虚假数据，被举报后将会被注销用户资格。</span>
                        <span class="redColor spanBlock">4.<span class="bold">注意：</span>谱木云链只是给大家提供自由、高效的信息交互SAAS工具，线上不支持交易，本身也不参与任何交易行为，所以用户之间的交易与谱木云链本无关(无需承担风险责任)！</span>
                    </div>
                    <!-- <span class="tip_top"><i class="iconfont icon-jindianzi returnImg"></i>注意:</span>
                     1.自定义同步是根据自己意原和需求，同步分享自己想分享的库存资源展现在企业云铺和谱木云仓里，同时云铺的库存可以实现按汇总库存的百分比显示云铺方数。 -->
                </div>
                <!-- <div class="syncCheckBox clearfix" @click="sync.is_promo = sync.is_promo==1?0:1">
                    <div class="syncName">同步到促销专区:</div>
                    <img :src="sync.is_promo == 1?'/cloud/checked.png':'/cloud/check.png'" class="syncImg"/>
                </div> -->
                <!-- <div class="syncCheckBox clearfix" @click="sync.visible = sync.visible==1?0:1">
                    <div class="syncName">隐藏公司名称:</div>
                    <img :src="sync.visible == 1?'/cloud/checked.png':'/cloud/check.png'" class="syncImg"/>
                </div> -->
                
            </el-form>
            <div class="elFormBoxBtnListCol">
                    <el-button class="funcPublicBtn" @click="dialogVisibleSync=!dialogVisibleSync" style="margin-right:15px!important;">取消</el-button>
                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="saveSync">确认</el-button>
                </div>
        </el-dialog>
        <!-- 云铺同步 END -->
        <el-dialog v-dialog-drag title="定价" :visible.sync="addDialogVisible" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
                <el-form :model="set_params" ref="add_form" class="clearfix dialogFormB">
                    <div class="syncCheckBox clearfix">
                        <el-form-item label="云铺单价：">
                            <el-input v-model="set_params.sales_price" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="addDialogVisible=!addDialogVisible" style="margin-right:15px!important;">取消</el-button>
                        <el-button  class="funcPublicBtn funcPublicBtnChecked" @click="setChangePrice">确定</el-button>
                    </div>
                </el-form>
        </el-dialog>
        <!-- 品名详情 START -->
        <el-dialog v-dialog-drag :visible.sync="breedDetailFlag" class="eldialog specTable" width="500px" :modal="false" title="品名规范">
            <div class="breedbox">
                <div>
                    <img src="/icon/sigh.png" style="width:20px;">
                    请将品名规范如下
                    <span class="tip_top">（不规范的品名数据将无法进行同步）</span>
                </div>
                <div style="overflow-y: auto;height: 363px;padding-top: 10px;">
                    <span v-for="list in breed_list" :key="list.name" :value="list.id" class="breedFilter">
                        <div style="padding: 0px 10px;">
                            {{list.name}}
                        </div>
                    </span>
                </div>
            </div>
        </el-dialog>
        <!-- 品名详情 END -->
        <!-- 云铺详情 -->
        <el-dialog v-dialog-drag :visible.sync="yunpuInstallDialog" class="eldialog specTable" width="650px" :modal="false" title="云铺设置">
            <div class="yunpubox">
                <div>
                    <div class="companySetBox clearfix">
                        <div class="companyTitleB">公司名称:</div>
                        <div class="companyContent">
                            {{companyName}}
                        </div>
                    </div>
                    <div class="companySetBox clearfix" style="height: 50px;">
                        <div class="companyTitleB">LOGO:</div>
                        <div class="companyContent">
                            <img :src="shopList.company_logo" class="uploadImage" style="width:60px;height: 60px;"/>
                        </div>
                    </div>
                    <div class="companySetBox clearfix">
                        <div class="companyTitle">公司介绍:</div>
                        <div class="companyContent">
                            {{view.company_intro}}
                        </div>
                    </div>
                    <div class="companySetBox clearfix">
                        <div class="companyTitle">主营项目:</div>
                        <div class="companyContent">
                            {{view.main_business}}
                        </div>
                    </div>
                    <div class="companySetBox clearfix">
                        <div class="companyTitle">公司地址:</div>
                        <div class="companyContent">
                            {{view.address}}
                        </div>
                    </div>
                    <div class="companySetBox clearfix">
                        <div class="companyTitle">联系方式:</div>
                        <div class="companyContent">
                            {{view.contact_phone}}
                        </div>
                    </div>
                </div>
                <div class="elFormBoxBtnListCol">
                    <el-button class="funcPublicBtn funcPublicBtnChecked" @click="modify">修改</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog v-dialog-drag :visible.sync="yunpusetDialog" class="eldialog specTable" width="650px" :modal="false" title="云铺修改">
            <div class="">
                <div class="shopNews">
                    <div class="companySetBox clearfix">
                        <div class="companyTitle">公司名称:</div>
                        <div class="companyContent">
                            {{companyName}}
                        </div>
                    </div>
                    <div class="companySetBox companySetBoxLogo clearfix">
                        <div class="companyTitle">LOGO:</div>
                        <div class="companyContent">
                            <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                                <img v-if="shopList.company_logo" :src="shopList.company_logo" class="uploadImage"/>
                                <img v-if="!shopList.company_logo" src="/icon/plus-default@2x.png" class="uploadImageAdd"/>
                            </el-upload>
                        </div>
                    </div>
                    <div class="companySetBox clearfix">
                        <div class="companyTitle">介绍:</div>
                        <div class="companyContent">
                            <el-input class="companyInp" type="textarea" v-model="shopList.company_intro"/>
                        </div>
                    </div>
                    <div class="companySetBox clearfix" style="margin-top: 40px;">
                        <div class="companyTitle">主营项目:</div>
                        <div class="companyContent">
                            <el-input class="companyInp" type="textarea" v-model="shopList.main_business"/>
                        </div>
                    </div>
                    <div class="companySetBox clearfix" style="margin-top: 40px;">
                        <div class="companyTitle">公司地址:</div>
                        <div class="companyContent">
                            <el-input class="companyInp" v-model="shopList.address"/>
                        </div>
                    </div>
                    <div class="companySetBox clearfix">
                        <div class="companyTitle">联系方式:</div>
                        <div class="companyContent">
                            <el-input class="companyInp" v-model="shopList.contact_phone"/>
                        </div>
                    </div>
                    <div class="elFormBoxBtnListCol" style="padding-top: 40px;">
                        <el-button class="funcPublicBtn" @click="yunpusetDialog=false" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="yunpuInstall">确认</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 图片上传 START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleImg" class="eldialog eldialogOneLabel accountDialog" width="500px" :modal="false" title="图片上传" custom-class="full_dialog">
            <div class="upimgOutBox clearfix">
                <div class="upImgBox" v-for="(item,index) in upImagesList" :key="index+'_index'">
                    <img src="/icon/top-delete-suspension.png" class="upImgRemove" @click="upImgRemove(item)"/>
                    <img :src="item" class="upImg"/>
                </div>
                <el-upload class="upload-demo" ref='upload_path' drag multiple :action="oss.host" :data="upload_data" :on-success="handleImagesSuccess" :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                    <img src="/icon/addProductImg.png" class="uploadImageAdd">
                </el-upload>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="funcPublicBtn funcPublicBtnChecked dialogBtn" @click="saveImgs">保存</el-button>
                <el-button class="funcPublicBtn dialogBtn" @click="dialogVisibleImg = false">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 图片上传 END -->
    </div>
    <div class="templete_box" v-else-if="codeshop==1||codeshop==0">
        <div class="templetes">
            <!-- 未开通店铺 -->
            <div class="newOPen" v-if="codeshop==1">
                <img src="../../assets/dianpu.png" style="margin:160px auto 0 auto;">
                <div>
                    <span class="font">线上店铺暂未开通</span>
                </div>
                <div class="button_top">
                    <button class="activateNow" @click="codeshop =0 ">立即开通</button>
                </div>
            </div>
            <!-- 填写店铺信息 -->
            <div class="addShop" v-if="codeshop==0">
                <div class="shopName">
                    <span class="font">店铺信息</span>
                </div>
                <div class="shopNews">
                    <div class="companySetBox clearfix">
                        <div class="companyTitle">公司名称:</div>
                        <div class="companyContent">
                            {{companyName}}
                        </div>
                    </div>
                    <div class="companySetBox companySetBoxLogo clearfix">
                        <div class="companyTitle">LOGO:</div>
                        <div class="companyContent">
                            <el-upload class="upload-demo" ref='upload_path' drag :action="oss.host" :data="upload_data" :on-success="handleSuccess" :before-upload="beforeUpload" accept=".png,.jpg,.jpeg,.PNG,.JPG,.JPEG">
                                <img v-if="shopList.company_logo" :src="shopList.company_logo" class="uploadImage"/>
                                <img v-if="!shopList.company_logo" src="/icon/plus-default@2x.png" class="uploadImageAdd"/>
                            </el-upload>
                        </div>
                    </div>
                    <div class="companySetBox clearfix">
                        <div class="companyTitle">介绍:</div>
                        <div class="companyContent">
                            <el-input class="companyInp" type="textarea" v-model="shopList.company_intro"/>
                        </div>
                    </div>
                    <div class="companySetBox clearfix" style="margin-top: 40px;">
                        <div class="companyTitle">主营项目:</div>
                        <div class="companyContent">
                            <el-input class="companyInp" type="textarea" v-model="shopList.main_business"/>
                        </div>
                    </div>
                    <div class="companySetBox clearfix" style="margin-top: 40px;">
                        <div class="companyTitle">公司地址:</div>
                        <div class="companyContent">
                            <el-input class="companyInp" v-model="shopList.address"/>
                        </div>
                    </div>
                    <div class="companySetBox clearfix">
                        <div class="companyTitle">联系方式:</div>
                        <div class="companyContent">
                            <el-input class="companyInp" v-model="shopList.contact_phone"/>
                        </div>
                    </div>
                    <div class="elFormBoxBtnListCol" style="padding-top: 40px;">
                        <el-button class="funcPublicBtn" @click="codeshop=1" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="addShopNews">确认</el-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import pagination from '../../components/pagination.vue'
    import tabletem from '../../components/table.vue'
    import saleMan from './component/saleManFields.vue'
    export default {
        components:{
            pagination,
            tabletem,
            saleMan
        },
        data(){
            return{
                tableLoading:false,
                selectRow:[],
                params:{
                    sync_status:'',
                    is_promo:'',
                    sync_cube_pct:'',
                    area_id:'',
                    breed_id:'',
                    brand_id:'',
                    grade_id:'',
                    thickness:'',
                    length:'',
                    per_page: 50,
                    page:1
                },
                isShowMore:false,
                last_page: 1,
                current_page: 1,
                total: 0,
                updataType:2,//2新增，3修改
                list : [],
                selectMapC:{
                    breed_id:[],
                    brand_id:[],
                    grade_id:[],
                },
                locationList:[],
                // dialog
                dialogVisible : false,
                tableCol:[	
                    {colName:"同步状态",colKey:"sync_status_text",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"同步百分比",colKey:"sync_cube_pct",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,},
                    {colName:"产品图片",colKey:"images",colWidth:80,isSetWidth:true,isCanClick:false,isShow:true,isStockImg:true,isColor:true},
                    {colName:"品名",colKey:"breed",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true,isDialogView:true,isColor:true},
                    {colName:"品牌",colKey:"brand",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"等级",colKey:"grade",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"规格",colKey:"spec",htmlNodeFunc(row) {
                        let color =`${String(row['thickness']+'*'+row['length']).length}`>50? 'red' : '';
                        return `<span style="color:${color}">${row['thickness']}*<span>${row['length']}</span></span>`;
                    },colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,},
                    {colName:"库存方数",colKey:"sales_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"同步方数",colKey:"sync_cube",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"云铺价",colKey:"sales_price",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"区域",colKey:"area_name",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true,isAreaDialogView:true,},
                    {colName:"仓库",colKey:"warehouse",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"同步属性",colKey:"is_promo_text",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"同步人",colKey:"sync_operator",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:180,isSetWidth:true,isCanClick:false,isShow:true}
                ],
                totalObj:{
                    sales_cube:'',
                    sync_cube:''
                },
                dialogVisibleSync:false,
                sync:{
                    stock:[],
                    is_promo:0,
                    sync_cube_pct:100,
                },
                arrList:{},
                addDialogVisible:false,
                set_params:{
                    stock:[],
                    sales_price:"",
                },
                filterDialogVisible:false,
                salefilter:[],
                oneSyncdialogVisibleSync:false,
                onesync:{
                    sync_cube_pct:100,
                },
                codeshop:999,
                code:999,
                companyName:localStorage.dw_erp_company_name,
                shopList:{
                    company_logo:"",
                    address:"",
                    company_intro:"",
                    main_business:"",
                    contact_phone:"",
                },
                upload_data : {},
				oss : {
                    host : "",
                },
                file_url : '',
                view:{
                    view_count:'',
                    contact_count:'',
                    follow_count:''
                },
                breed_list:[],
                breedDetailFlag:false,
                yunpuInstallDialog:false,
                yunpusetDialog:false,
                isUpImg:0,
                dialogVisibleImg:false,
                upImgObj:{
                    stock:[],
                    images:[]
                },
                upImagesList:[],
            }
        },
        created(){
            this.postFunc("/erp/warehouse.area.select",{},res=>{
                this.locationList=res.data.data;
            },error=>{
                this.tip(error.data.message,"warning")
            });
            this.storeInfo();
            this.company();
            this.breedList();
        },
        methods:{
            //获取可同步的品名
            breedList(){
                this.postFunc('erp/cloud.stock.breed',{},res=>{
                    this.breed_list = res.data.data;
                })
            },
            storeInfo(){
                this.postFuncLoading("erp/cloud.store.info",{},res=>{
                    if(res.data.code==0){
                        this.code=0
                        this.getList();
                    }
                    this.view.view_count = res.data.data.view_count;
                    this.view.contact_count = res.data.data.contact_count;
                    this.view.follow_count = res.data.data.follow_count;
                    this.view =  res.data.data
                },error=>{  
                    if(error.data.code=='1400'){
                        this.codeshop=1
                    }
                }
                )
            },
            //电话
            filterDialogVisibleClose(){
                this.filterDialogVisible=!this.filterDialogVisible;
            },
            //云铺设置
            yunpuInstallDialogClose(){
                this.yunpuInstallDialog=!this.yunpuInstallDialog;
            },
            //获取公司信息
            company(){
                this.postFunc("/erp/company.info",{},res=>{
                    this.shopList.company_logo = res.data.data.picture;
                    this.shopList.address = res.data.data.address;
                    this.shopList.contact_phone = res.data.data.mobile;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getSelectWarehouseList(target){
                this.$getSelectWarehouseList(target,this.params).then(res=>{
                    this.selectMapC[res.data.data.target]=res.data.data.result;
                })
            },
            //自定义同步
            syncClick(){
                if(this.selectRow.length<=0){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                     try{
                         let arrnew = this.selectRow.map((item,index) => {
                             return Object.assign({},{'area_id':item.area_id,'warehouse_id':item.warehouse_id,"breed_id":item.breed_id,'brand_id':item.brand_id,"grade_id":item.grade_id,'thickness':item.thickness,"length":item.length})
                         })
                         this.sync.stock=arrnew;
                         this.selectRow.forEach(item=>{
                             if(item.power_operation_list.setSync==false){
                                 this.tip('选中数据有不可操作项',"warning")
                                 throw new Error();  
                             }else{
                                 this.dialogVisibleSync = true;
                             }
                         })
                     }catch(e){

                     }
                }
            },
            saveSync(){
                this.$confirm('是否确定同步?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("erp/cloud.stock.sync",this.sync,()=>{
                        this.tip("同步成功","success")
                        this.dialogVisibleSync = false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //一键同步
            oneSync(){
                this.oneSyncdialogVisibleSync=true;
            },
            onesaveSync(){
                this.$confirm('是否确定同步?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("erp/cloud.stock.sync.quick",this.onesync,()=>{
                        this.tip("一键同步成功","success")
                        this.oneSyncdialogVisibleSync = false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //获取列表数据
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                // $postColumnList
                this.postFunc("erp/cloud.stock.list",this.params,res=>{
                    this.list=res.data.data.data;
                    this.totalObj=res.data.data.stat;
                    this.last_page=parseInt(res.data.data.last_page);
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.$refs.pagination.flag = true;
                    this.postFunc("erp/cloud.store.user.list",{},res=>{
                        this.salefilter = res.data.data;
                    })
                   this.list.forEach((item,ind)=>{
                        // if(item.inbound_time){
                        //     this.list[ind].inbound_time = this.formatTime(this.list[ind].inbound_time+"000")
                        // }else{
                        //     this.list[ind].inbound_time = "";
                        // }
                        item.baseColor = "";
                        if(item.area_id==0){
                            item.baseColor="red";
                        }
                        if(item.breed){
                            let falg = true;
                            this.breed_list.filter(function(el){
                                if(el.name.indexOf(item.breed) !=-1){
                                    falg = false;
                                }
                            })
                            item.isDialogViewbreed = falg;
                        }
                        if(item.area_id==''){
                            item.isDialogViewArea = true;
                        }  
                        if(item.sync_cube_pct!=0){
                            item.sync_cube_pct=item.sync_cube_pct+'%'
                        }
                        if(item.power_operation_list.cancelSync==true||item.power_operation_list.setPrice==true||item.power_operation_list.setSync==true){
                            item.isCanSelection=false;
                        }else{
                            item.isCanSelection=true;
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getRow(row){
                this.selectRow = row;
            },
            //定价
            tiao(){
                if(this.selectRow.length<=0){
                    this.tip("请选择数据","warning")
                    return;
                }
                try{
                    this.selectRow.forEach(item=>{
                         if(item.power_operation_list.setPrice==false){
                            this.tip('请选择同步状态的库存修改定价',"warning");
                            throw new Error();    
                        }
                         else{
                            this.addDialogVisible = true;
                            let arr = new Array();
                            let arrnew = this.selectRow.map((item,index) => {
                                    return Object.assign({},{'area_id':item.area_id,'warehouse_id':item.warehouse_id,"breed_id":item.breed_id,'brand_id':item.brand_id,"grade_id":item.grade_id,'thickness':item.thickness,"length":item.length})
                            })
                            this.set_params.stock=arrnew;
                        }
                    })
                }catch(e){

                }
            },
            setChangePrice(){
                this.$confirm('是否确认定价?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFunc("erp/cloud.stock.sync.price",this.set_params,()=>{
                        this.tip("定价成功","success")
                        this.addDialogVisible=false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            cancelSync(){
                if(this.selectRow.length<=0){
                    this.tip("请选择数据","warning")
                    return;
                }else{
                    let flag = true;
                    let arrnew = this.selectRow.map((item,index) => {
                            return Object.assign({},{'area_id':item.area_id,'warehouse_id':item.warehouse_id,"breed_id":item.breed_id,'brand_id':item.brand_id,"grade_id":item.grade_id,'thickness':item.thickness,"length":item.length})
                    })
                    if(flag){
                        this.$confirm('是否确定撤销同步?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.postFunc("erp/cloud.stock.sync.cancel",{stock:arrnew},()=>{
                                this.tip("撤销成功","success")
                                this.getList();
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }).catch(()=>{});
                    }else{
                        this.tip("有资源未同步，无需撤销同步。","warning")
                    }
                }
            },
            //销售员列设置
            addfilterDialogVisible(){
                this.filterDialogVisible =!this.filterDialogVisible;
                this.postFunc("erp/cloud.store.user.list",{},res=>{
                    this.salefilter = res.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            dialogViewClick(row){
                if(row.type=='breed'){
                    this.breedDetailFlag = true;
                }
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.getList()
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },
            //店铺信息确认
            addShopNews(){
                this.postFunc('erp/cloud.store.apply',this.shopList,res=>{
                    this.storeInfo()
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //修改
            modify(){
                this.shopList = this.view
                this.yunpusetDialog = !this.yunpusetDialog;
            },
            yunpuInstall(){
                this.postFunc('erp/cloud.store.update',this.shopList,res=>{
                    this.yunpusetDialog=false;
                    this.yunpuInstallDialog = false;
                    this.storeInfo();
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //上传图片
            bacthUpImg(){
                if(this.selectRow.length<1){
                    this.tip("请选择数据","warning")
                }else{
                    this.selectRow.forEach((item,index)=>{
                        if(this.selectRow[index].power_operation_list.setImage==false){
                            this.tip('选中数据有不可操作项',"warning")
                            return
                        }else{
                            let arrnew = this.selectRow.map((item,index) => {
                                return Object.assign({},{'area_id':item.area_id,'warehouse_id':item.warehouse_id,"breed_id":item.breed_id,'brand_id':item.brand_id,"grade_id":item.grade_id,'thickness':item.thickness,"length":item.length})
                            })
                            this.upImgObj.stock=arrnew;
                            if(this.selectRow.length == 1){
                                this.upImagesList = Array.isArray(this.selectRow[0].images)?JSON.parse(JSON.stringify(this.selectRow[0].images)):[];
                            }
                            this.dialogVisibleImg = true;
                            this.isUpImg = 1;
                        }
                    })
                }
            },
            upImgRemove(url){
                this.upImagesList.forEach((item,index)=>{
                    if(item == url){
                        this.upImagesList.splice(index,1)
                    }
                })
            },
            saveImgs(){
                this.$confirm('是否确认上传?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.upImgObj.images = this.upImagesList;
                    this.postFuncLoading("erp/cloud.stock.sync.image",this.upImgObj,()=>{
                        this.tip('上传成功','success');
                        this.dialogVisibleImg = false;
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            handleImagesSuccess(file){
                this.upImagesList.push(file.data.base_url);
            },

            //图片
            handleSuccess(res) {
                this.shopList.company_logo = res.data.base_url;
                this.$refs.upload_path.clearFiles();
            },
            beforeUpload(file) {
                this.file = file;
                return this.getOss();
            },
            getOss(){
                let self = this;
                return new Promise((resolve, reject) =>{
                    window.axios.post(window.oss_url+"/tool/v1/oss.policy.get",{
                        operate_code : "shop-excel"
                    }).then((response) => {
                        if(response.data.code == 0){
                            self.oss = response.data.data;
                            this.upload_data = {
                                name: self.file.name,
                                key : self.oss.dir + "${filename}",
                                policy : self.oss.policy,
                                OSSAccessKeyId : self.oss.accessid,
                                success_action_status : "200",
                                callback : self.oss.callback,
                                signature : self.oss.signature,
                                'Cache-Control' : self.oss.cache_control,
                            }
                            resolve();
                        }
                    }).catch(()=>{
                        reject();
                    })
                })
            }
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisibleImg":function(val){
                if(!val){
                    this.isUpImg = 0;
                    this.upImgObj = {kid:[],images:[]}
                    this.upImagesList = [];
                }
            },
        }
    }
</script>
<style scoped>
    .syncCheckBox{width:235px;margin: auto;margin-top:15px;cursor: pointer;}
    .syncName{font-size: 12px;float: left;width:100px;text-align: left;;margin-left:15px;}
    .syncImg{width:15px;height:15px;display: block;float: left;margin-left:10px;}
    .templetes{align-items: center;background-color: #fff;height: 100%;}
    .font{font-size: 24px;color: #777;}
    .newOPen{width: 100%;height: 100%;}
    .button_top{margin-top: 30px;}
    .activateNow{padding: 0px 0px;width: 100px;font-size: 15px;border-radius: 3px;line-height: 25px;background-color: #b21111!important;color: #fff!important;
    border-color: #b21111;}
    .addShop{width: 700px;margin:100px auto 0 auto;}
    .shopName{border-bottom: 1px solid #DCDFE6;}
    .shopNews{width:350px;margin: 30px 200px;}
    .companySetBox{margin-bottom:10px;margin-top:20px;}
    .companyTitle{font-size: 14px;float: left;margin-right:10px;height:30px;line-height: 30px;width:60px;}
    .companyContent{float: left;font-size: 14px;height:30px;line-height: 30px;}
    .companyInp{width:280px;}
    .companySetBoxLogo{height:110px;}
    .upload-demo{width:100px;height:100px;}
    .uploadImage{width:100px;height:100px;}
    .uploadImageAdd{width:35px;height: 35px;margin:auto;margin-top:32.5px;}
    /* .elFormBoxBtnListCol {text-align: right;} */
    .imgIcon{margin-left: 0;border-radius: 3px;line-height: 31px;cursor: pointer;border-color: #666;float: left;margin-right: 15px;font-weight: 600;
    }
    .specTable >>> .el-dialog__body{padding:0;border-radius: 0 0 5px 5px;overflow: hidden;}
    .breedbox{text-align: left;padding: 10px;}
    .breedFilter{background-color: #f2f2f2;color: #999;border-radius: 5px;float: left;margin-right: 10px;margin-bottom: 10px;}
    .yunpubox{padding: 20px;}
    .companyTitleB{font-size: 14px;float: left;margin-right:10px;height:30px;line-height: 30px;}

    .upimgOutBox .uploadImageAdd{width:100%;height:100%;margin-top:0px;}
    .upimgOutBox .upload-demo{float: left;width:102px;height:102px;overflow: hidden;}
    .upimgOutBox .upImgBox{position: relative;width:102px;height:102px;float: left;margin-right:10px;margin-bottom:10px;position: relative;}
    .upimgOutBox .upImg{display: block;width:100%;height:100%;}
    .upimgOutBox .upImgRemove{width:20px;height:20px;position: absolute;top:5px;right:5px;cursor:pointer;}
    .tip_top{color: #FCB917;}
    .textDiv{display:flex;font-size: 12px;border: 1px dashed #e4e4e4;border-radius: 5px;padding: 10px;margin: 0 43px;}
    .spanBlock{display: block;}
</style>